<template>
  <div :class="{ textarea, lengthCounter }" class="jinput" :style="inputStyle">
    <label
      v-if="label && label.length"
      :for="name"
    >{{ this.label }}</label>
    <input
      :autofocus="autofocus"
      :accept="accept"
      class="inpt--cstm"
      v-if="!isDateTime && !textarea"
      :ref="id"
      :id="id"
      :type="type"
      :name="name"
      :placeholder="placeholder"
      :value="value"
      @input="onInput"
      @change="onChange"
      @keypress="(e) => $emit('onKeyPress', e)"
      :required="
      required"
      :pattern="pattern"
      :maxlength="maxlength"
      :rows="rows"
      @keydown="(e) => $emit('onKeyDown', e)"
      :disabled="disabled"
      @blur="(e) => $emit('blur', e)"
    />
    <textarea
      :autofocus="autofocus"
      @blur="(e) => $emit('blur', e)"
      :accept="accept"
      class="inpt--cstm"
      v-if="!isDateTime && textarea"
      :rows="rows"
      :ref="id"
      :id="id"
      :type="type"
      :name="name"
      :placeholder="placeholder"
      :value="value"
      @input="onInput"
      @change="onChange"
      @keypress="(e) => $emit('onKeyPress', e)"
      :required="required"
      :pattern="pattern"
      :maxlength="maxlength"
      :disabled="disabled"
      @keydown="(e) => $emit('onKeyDown', e)"
    />
    <div v-if="emoji" class="add-emoji emoji-icon" :style="iconStyle">
      <VIcon :id="`emoji-icon-${id}`" @click="toggleEmojiPicker" name="emoji-line" class="emoji_icon"></VIcon>
    </div>
    <!-- Emoji Picker Panel -->
    <div v-if="isEmojiPickerOpen" class="popover-backdrop" @click="openEmoji = false"></div>
    <div v-if="isEmojiPickerOpen" class="popover-panel emoji-popover-panel">
      <EmojiPicker :native="true" @select="(emoji) => fillParameter(emoji.i, 2)" />
    </div>

    <div v-if="insert" class="add-emoji insert-icon" :style="iconStyle">
      <VIcon :id="`insert-icon-${id}`" @click="insertParam" name="curly-brackets-line"></VIcon>
    </div>
    <!-- Variable Insert Panel -->
    <div v-if="isPopoverOpen" class="popover-backdrop" @click="isPopoverOpen = false"></div>
    <div v-if="isPopoverOpen" class="popover-panel insert-popover-panel">
      <div class="insert-content">
        <div v-for="(item, index) in insertOptions" :key="index" @click="fillParameter(item.key)">
          {{ item.text }}
        </div>
        <div @click="showCustomFieldModal = true">Custom Field</div>
        <div @click="showBotVariableModal = true">Bot Variable</div>
        <div>
          <input type="text" placeholder="Custom Variable..." v-model="customInsert" class="input--cstm" />
          <VIcon v-if="customInsert" @click="onCustomInsertChange" name="add-line"></VIcon>
        </div>
      </div>
    </div>

    <span v-if="lengthCounter && maxlength" :style="lengthStyle" class="char-length">{{ value?.length || 0 }}/{{ maxlength }}</span>
    <CustomDataFieldPickerModal v-if="showCustomFieldModal" v-model:isOpen="showCustomFieldModal" @selected="fillParameter" />
    <BotVariablePickerModal :bot_id="botId" v-model:isOpen="showBotVariableModal" @selected="fillParameter" :formattedOutput="true"></BotVariablePickerModal>
  </div>
</template>

<script>
import EmojiPicker from 'vue3-emoji-picker'

// import css
import 'vue3-emoji-picker/css'
import CustomDataFieldPickerModal from "./CustomDataFieldPickerModal.vue";
import BotVariablePickerModal from "./BotVariablePickerModal.vue";
import { useUIStore } from '@/stores/ui';

export default {
  components: {
    EmojiPicker,
    CustomDataFieldPickerModal, BotVariablePickerModal
  },
  emits: ["onKeyPress", "input", "onInput", "change", "onKeyDown", "onInsert", "blur"],
  props: {
    label: {
      type: String,
    },
    pattern: {
      type: String,
    },
    id: {
      type: String,
      default: new Date().getTime().toString() + parseInt(Math.random() * 100),
    },
    type: {
      type: String,
      default: "text",
    },
    name: {
      type: String,
      default: `${Date.now().toString() + parseInt(Math.random() * 100)}-input`,
    },
    placeholder: {
      type: String,
    },
    value: {
      required: true,
      default: ""
    },
    required: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
    },
    emoji: {
      type: Boolean,
      default: false,
    },
    insert: {
      type: Boolean,
      default: false,
    },
    textarea: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 3,
    },
    maxlength: {
      type: Number,
    },
    lengthCounter: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputStyle: {
      type: Object,
      default: () => {},
    },
    lengthStyle: {
      type: Object,
      default: () => {},
    },
    bot_id: {
      type: String,
      default: ""
    },
    iconStyle: {
      type: Object,
      default: () => {},
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      files: undefined,
      openEmoji: false,
      timestamp: Date.now(),
      showBotVariableModal: false,
      showCustomFieldModal: false,
      customInsert: undefined,
      isPopoverOpen: false,
      insertOptions: [{
        text: "User's First Name",
        key: "<userfirstname>"
      },
      {
        text: "User's Last Name",
        key: "<userlastname>"
      },
      {
        text: "User's Full Name",
        key: "<userfirstname> <userlastname>"
      },
      {
        text: "User's Mobile Number",
        key: "<userphone>"
      },
      {
        text: "User's Email ID",
        key: "<useremail>"
      }]
    };
  },
  computed: {
    isDateTime() {
      return (
        this.type === "date" || this.type === "time" || this.type === "datetime"
      );
    },
    isEmojiPickerOpen() {
      return this.emoji && this.openEmoji;
    },
    botId() {
      return this.bot_id;
    }
  },
  watch: {
    openEmoji() {
      if(this.openEmoji) document.addEventListener('click', this.clickHandler);
      else document.removeEventListener('click', this.clickHandler);
    }
  },
  methods: {
    toggleEmojiPicker() {
      if(this.openEmoji) {
        this.openEmoji = false;
      } else {
        this.openEmoji = true;
      }
    },
    onInput(e) {
      if (!this.isDateTime) {
        this.$emit("onInput", e.target.value);
        this.type === "file" ? (this.files = e.target.files) : 0;
      } else {
        this.$emit("input", e);
      }
    },
    onChange() {
      switch (this.type) {
        case "file":
          this.$emit("change", this.files);
          break;
        default:
          this.$emit("change", this.value);
      }
    },
    insertParam() {
      this.$emit('onInsert');
      if(!this.isPopoverOpen) this.isPopoverOpen = true;
      else this.isPopoverOpen = false;
    },
    onCustomInsertChange() {
      if(this.customInsert && this.customInsert.length) {
        this.fillParameter(this.customInsert);
        this.customInsert = undefined;
      }
    },
    fillParameter(v, requiredBufferToAdd = 10) {
      if(this.maxlength && this.maxlength < this.value.length + requiredBufferToAdd) {
        useUIStore().updateToast({
          open: true,
          message: "Max character length reached!",
          type: "warning"
        })
      } else {
        const textarea = this.$refs[this.id];
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        this.$emit("onInput", this.value.substring(0, start) + v + this.value.substring(end));
        //this.$emit('change', this.value);
        this.isPopoverOpen = false;
        this.openEmoji = false;
        this.$nextTick(() => {
          textarea.setSelectionRange(start + v.length, start + v.length);
          textarea.focus();
        });
      }
    }
  },
};
</script>

<style scoped lang="scss">
.popover-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;
}
.popover-panel {
  position: absolute;
  z-index: 10000;
  background: var(--white);
  border-radius: 8px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.15);
}
.emoji-popover-panel {
  bottom: 35px;
  right: 0;
}
.insert-popover-panel {
  bottom: 35px;
  right: 30px;
  width: 250px;
  max-height: 300px;
  overflow-y: auto;
}
.insert-content {
  div {
    padding: 10px;
    border-bottom: 1px solid var(--gray-01);
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    &:hover {
      background: var(--gray-01);
    }
    &:last-child {
      border-bottom: none;
    }
    input {
      width: 100%;
      outline: none;
      border: none;
      border-radius: 8px;
      height: 30px;
      padding: 10px;
      background: var(--background-primary);
    }
  }
}

.add-emoji {
  position: absolute;
  cursor: pointer;
  font-size: 1.2rem;
  bottom: 5px;
  &.emoji-icon {
    color: var(--gray-04);
    right: 10px;
  }
  &.insert-icon {
    color: var(--gray-04);
    right: 40px;
  }
}
.jinput {
  margin: 0px 5px 0px 5px;
  width: 100%;
  position: relative;
  border-radius: 5px;
  background: var(--background-primary);
  color: var(--black);
  &.lengthCounter {
    padding-bottom: 30px;
  }
}
.jinput.textarea {
  padding: 10px 10px 30px 10px;
  .add-emoji {
    bottom: 10px;
  }
}
.jinput:focus {
  border: 1px solid black;
}
.jinput > label {
  margin-bottom: 10px;
  font-size: 14px;
  font-size: 0.8rem;
  font-weight: bold;
}
.jinput > input,
.jinput > textarea {
  outline: none;
  border: none;
  resize: none;
  width: 100%;
  background: var(--background-primary);
  color: var(--black);
  border-radius: 5px;
  padding: 5px;
  max-height: 100px;
}
.jinput input.error,
.jinput textarea.error {
  outline: 1px solid red;
}
.char-length {
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 0.9rem;
  color: var(--gray-04);
  width: fit-content;
}
.v3-emoji-picker {
  width: auto;
}
.emoji_icon {
  font-size: 20px;
  padding-bottom: 5px;
  color: var(--gray-04);
}
</style>
